
import * as React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { AppRoute } from './types'
import { UsersListPage } from './pages'
import { RolesListPage } from './pages/roles/RolesPage'
import { USERS_ROUTES } from './routes-typed'

export const usersRoutesMap: Record<string, string> = {
  usersList: USERS_ROUTES.usersList.path,
  groupsList: USERS_ROUTES.groupsList.path,
  labelsPage: USERS_ROUTES.labelsPage.path,
  rolesList: USERS_ROUTES.rolesList.path,
}

// The groups and labels tabs are hidden (see UsersLayout); old links land on the user list.
const UsersListRedirect: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()
  return <Navigate to={USERS_ROUTES.usersList.buildPath({ companyId: companyId! })} replace />
}

export const usersRoutes: AppRoute[] = [
  {
    path: usersRoutesMap.groupsList,
    component: UsersListRedirect,
    exact: true,
  },
  {
    path: usersRoutesMap.labelsPage,
    component: UsersListRedirect,
    exact: true,
  },
  {
    path: usersRoutesMap.rolesList,
    component: RolesListPage,
    exact: true,
  },
  {
    path: usersRoutesMap.usersList,
    component: UsersListPage,
    exact: true,
  },
]
